import { render, staticRenderFns } from "./NegociacaoAlterarResposta.vue?vue&type=template&id=1c7962af"
import script from "./NegociacaoAlterarResposta.vue?vue&type=script&lang=js"
export * from "./NegociacaoAlterarResposta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports